import { useAppDispatch } from 'hooks/useAppDispatch';
import { updatePasswordAction } from '../store/profile/profile-actions';
import { UpdatePasswordRequest } from '../types/profile';

export const useUpdatePassword = () => {
  const dispatch = useAppDispatch();

  const updatePassword = async (request: UpdatePasswordRequest) => {
    await dispatch(updatePasswordAction(request));
  };

  return updatePassword;
};
